export interface ShakeConfig {
  active: boolean;
  intensity: number;
  duration: number;
  elapsed: number;
}

export const shakeState: ShakeConfig = {
  active: false,
  intensity: 0,
  duration: 0,
  elapsed: 0,
};

export function triggerShake(intensity: number, duration: number) {
  shakeState.active = true;
  shakeState.intensity = intensity;
  shakeState.duration = duration;
  shakeState.elapsed = 0;
}
